import type { LearnType } from '@shared/config'

export default abstract class AbstractTrainerState {
  public abstract type: LearnType
  public abstract attempts: number
  public abstract timeLeft: number | null
  public abstract status: unknown
  public maxAttempts: number
  public score: number
  public maxScore: number

  protected constructor() {
    this.maxAttempts = 0
    this.score = 0
    this.maxScore = 0
  }

  get isInProgress() {
    return false
  }

  get isFailed() {
    return false
  }

  get isFailedByDeadline() {
    return false
  }

  get isFailedByAntiplagiat() {
    return false
  }

  get isPassed() {
    return false
  }

  get isOnCheck() {
    return false
  }

  get isCompleted() {
    return this.isFailed || this.isPassed || this.isOnCheck
  }
}
